/* tslint:disable */
/* eslint-disable */
/**
 * SISCC Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ImageSeries,
    ImageSeriesFromJSON,
    ImageSeriesFromJSONTyped,
    ImageSeriesToJSON,
    ItemState,
    ItemStateFromJSON,
    ItemStateFromJSONTyped,
    ItemStateToJSON,
    MenuNode,
    MenuNodeFromJSON,
    MenuNodeFromJSONTyped,
    MenuNodeToJSON,
} from './';

/**
 * 
 * @export
 * @interface LoadConfigResponse
 */
export interface LoadConfigResponse {
    /**
     * 
     * @type {Array<MenuNode>}
     * @memberof LoadConfigResponse
     */
    menus: Array<MenuNode>;
    /**
     * 
     * @type {Array<ItemState>}
     * @memberof LoadConfigResponse
     */
    items: Array<ItemState>;
    /**
     * 
     * @type {string}
     * @memberof LoadConfigResponse
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof LoadConfigResponse
     */
    configurationString: string;
    /**
     * 
     * @type {Array<ImageSeries>}
     * @memberof LoadConfigResponse
     */
    imageSeries: Array<ImageSeries>;
}

export function LoadConfigResponseFromJSON(json: any): LoadConfigResponse {
    return LoadConfigResponseFromJSONTyped(json, false);
}

export function LoadConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoadConfigResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'menus': ((json['menus'] as Array<any>).map(MenuNodeFromJSON)),
        'items': ((json['items'] as Array<any>).map(ItemStateFromJSON)),
        'model': json['model'],
        'configurationString': json['configurationString'],
        'imageSeries': ((json['imageSeries'] as Array<any>).map(ImageSeriesFromJSON)),
    };
}

export function LoadConfigResponseToJSON(value?: LoadConfigResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'menus': ((value.menus as Array<any>).map(MenuNodeToJSON)),
        'items': ((value.items as Array<any>).map(ItemStateToJSON)),
        'model': value.model,
        'configurationString': value.configurationString,
        'imageSeries': ((value.imageSeries as Array<any>).map(ImageSeriesToJSON)),
    };
}


